import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { Row, Col } from 'react-bootstrap'

// import data from './data'
import addressIcon from './addressIcon.svg'
import url from '../../config/url'

export default ({ setPortfolio, data = [] }) => {
  return (
    <Wrapper className="animated fadeInUp">
      {data
        .sort((a, b) => a.position - b.position)
        .map(({ id, name, address, avatar, quote, portfolio = [] }, i) => (
          <>
            <React.Fragment key={i}>
              <Row>
                <Col md={3}>
                  <AvatarImage src={url + avatar} alt={name} />
                </Col>
                <Col md={9}>
                  <Row>
                    <Col xs={7} md={7}>
                      <Name>{name}</Name>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: 30,
                        }}>
                        <img
                          src={addressIcon}
                          style={{ marginRight: 10, width: 20, height: 20 }}
                          alt={address}
                        />
                        <Address>{address}</Address>
                      </div>
                    </Col>

                    <Col xs={5} md={5}>
                      {/* <Button>Выбрать и начать работу</Button> */}
                      <Profile onClick={() => setPortfolio(id)}>
                        Посмотреть портфолио
                      </Profile>
                    </Col>
                  </Row>
                  <Quote dangerouslySetInnerHTML={{ __html: quote }} />
                </Col>
              </Row>

              <Slider {...sliderSettings}>
                {portfolio.map((el, i) => (
                  <div
                    style={{
                      overflow: 'hidden',
                    }}
                    key={i}>
                    <SliderImage src={url + el.img} alt={el.name} />
                    <SliderName>{el.name}</SliderName>
                  </div>
                ))}
              </Slider>
              <div style={{ marginBottom: 50 }}></div>
            </React.Fragment>
          </>
        ))}
    </Wrapper>
  )
}

const sliderSettings = {
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 530,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

const Wrapper = styled.div`
  /* position: relative; */
  margin-top: 30px;
  overflow: hidden;
  overflow-y: auto;
`

const Name = styled.h3`
  margin-bottom: 20px;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
`
const Avatar = styled.img`
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto 20px;
  border-radius: 50%;
`
const AvatarImage = styled.div`
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto 20px;
  background: #fff url(${props => props.src}) no-repeat center center;
  background-size: 100px auto;
  border-radius: 50%;
`
const Address = styled.div`
  font-style: normal;
  font-weight: normal;
  color: #fff;
  font-size: 16px;
  line-height: 25px;
`
const Quote = styled.p`
  margin: 20px 0 50px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  opacity: 0.7;
`
const Profile = styled.div`
  display: block;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background-color: #2568e4;
  border-radius: 7px;
  padding: 5px 0;
`
const SliderImage = styled(Avatar)`
  border-radius: none;
  position: relative;
  border-radius: 0px;
  margin: auto;
`
const SliderName = styled.div`
  color: red;
  margin: 10px 0;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
`
